import React, { useContext } from "react";
import FlexButton from "./FlexButton";
import { colors } from "../assets/colors";
import ThemeContext from "../context/themeContext";

export default function ButtonTabs({ item, activeTabs, setActiveTabs, index }) {
  const themeSettings = useContext(ThemeContext);
  const isDark = themeSettings.settings.theme === "DARK" ? true : false;
  return (
    <FlexButton
      title={item.title}
      color="default"
      sx={{
        background: activeTabs === item.id ? colors.btnGold : "transparent",
        height: "100%",
        padding: "10px",
        borderRadius: index === 0 ? "10px 0px 0px 0px" : "0px",
        textTransform: "none",
        color: activeTabs !== item.id && isDark ? colors.white : colors.black,
        "&:hover": {
          background: activeTabs === item.id ? colors.btnGold : "transparent",
          color: activeTabs !== item.id && isDark ? colors.white : colors.black,
        },
      }}
      onClick={() => setActiveTabs(item.id)}
    />
  );
}
